import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\GetStatusTaskController::__invoke
* @see app/Http/Controllers/Import/GetStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}/status'
*/
const GetStatusTaskController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStatusTaskController.url(args, options),
    method: 'get',
})

GetStatusTaskController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}/task/{importTask}/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\GetStatusTaskController::__invoke
* @see app/Http/Controllers/Import/GetStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}/status'
*/
GetStatusTaskController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return GetStatusTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\GetStatusTaskController::__invoke
* @see app/Http/Controllers/Import/GetStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}/status'
*/
GetStatusTaskController.get = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStatusTaskController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\GetStatusTaskController::__invoke
* @see app/Http/Controllers/Import/GetStatusTaskController.php
* @route '/api/import/{import}/task/{importTask}/status'
*/
GetStatusTaskController.head = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetStatusTaskController.url(args, options),
    method: 'head',
})

export default GetStatusTaskController